import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IonPopover } from '@ionic/angular';

@Component({
  standalone: false,
  selector: 'app-datetime-item',
  templateUrl: './datetime-item.component.html',
  styleUrls: ['./datetime-item.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatetimeItemComponent),
      multi: true
    }
  ]
})
export class DatetimeItemComponent {
  @Input() presentation: string;
  @Input() min: string;
  @Input() max: string;
  @Input() label: string;
  @Input() preferWheel: boolean;
  @Input() minuteValues: string;
  @ViewChild('datetimepopover') popover: IonPopover;

  value: any;

  disabled = false;
  onChange: any = () => { };
  onTouched: any = () => { };

  constructor() { }

  async openDatePicker() {
    if (this.popover) {
      await this.popover.present();
    }
  }

  updateValue(ev) {
    this.onChange(new Date(ev.detail.value).toISOString());
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

}
